// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityApplicationWorkflows = {
  actions: {
    applicationGrantRules: "利用ルール",
    roleMappings: "ロールマッピング",
    credentials: "接続資格情報",
    roleCatalogs: "ロールディレクトリ",
    syncRoleCatalog: "ロールディレクトリを同期",
    memberSnapshots: "メンバー要約",
    syncMemberSnapshots: "メンバー要約を同期",
    syncSourceRequired:
      "まずアプリの metadata_json.platform_sync_base_url に同期 API URL を設定してください",
    applicationContext: "アプリコンテキスト",
    createGrant: "利用ルールを作成",
    createRoleMapping: "アプリロールマッピングを作成",
    rotateCredential: "アクセス資格情報をローテーション",
    enableApplication: "アプリを有効化",
    disableApplication: "アプリを停止",
  },
  drawers: {
    applicationGrant: "アプリ利用ルール · {name}",
    applicationGrantShort: "アプリ利用ルール",
    applicationRoleMapping: "アプリロールマッピング · {name}",
    applicationRoleMappingShort: "アプリロールマッピング",
    credentials: "アプリアクセス資格情報 · {name}",
    credentialsShort: "アプリアクセス資格情報",
    roleCatalogs: "ロールディレクトリ · {name}",
    roleCatalogsShort: "ロールディレクトリ",
    memberSnapshots: "メンバー要約 · {name}",
    memberSnapshotsShort: "メンバー要約",
    applicationContext: "アプリコンテキスト · {name}",
    applicationContextShort: "アプリコンテキスト",
  },
  alerts: {
    credentialIssued:
      "新しい Client Secret を生成しました。今回のみ表示されます。直ちにアプリ設定へ保存してください。",
    applicationEntryUnitsHint:
      "現在の `exam` は1つの業務製品レコードですが、接入層では `exam-admin / exam-candidate` の2入口として理解します。",
  },
  confirms: {
    removeApplicationGrantTitle: "アクセスルールを削除",
    removeApplicationGrantDescription: "{subject} の {access} アクセスルールを削除しますか？",
    updateApplicationStatusTitle: "アプリ状態を更新",
    updateApplicationStatusDescription: "{application} を {status} に更新しますか？",
    removeRoleMappingTitle: "アプリロールマッピングを削除",
    removeRoleMappingDescription: "{from} -> {to} を削除しますか？",
  },
  messages: {
    applicationGrantRemoved: "アプリ利用ルールを削除しました",
    applicationGrantRemoveFailed: "アプリ利用ルールの削除に失敗しました",
    roleMappingRemoved: "アプリロールマッピングを削除しました",
    roleMappingRemoveFailed: "アプリロールマッピングの削除に失敗しました",
    credentialActivated: "資格情報を有効化しました",
    credentialActivateFailed: "資格情報の有効化に失敗しました",
    credentialDeactivated: "資格情報を無効化しました",
    credentialDeactivateFailed: "資格情報の無効化に失敗しました",
    applicationUpdated: "アプリを更新しました",
    applicationCreated: "アプリを作成しました",
    applicationUpdateFailed: "アプリの更新に失敗しました",
    applicationCreateFailed: "アプリの作成に失敗しました",
    noTargetApplication: "対象アプリが選択されていません",
    applicationGrantCreated: "アプリ利用ルールを作成しました",
    applicationGrantCreateFailed: "アプリ利用ルールの作成に失敗しました",
    roleMappingUpdated: "アプリロールマッピングを更新しました",
    roleMappingCreated: "アプリロールマッピングを作成しました",
    roleMappingUpdateFailed: "アプリロールマッピングの更新に失敗しました",
    roleMappingCreateFailed: "アプリロールマッピングの作成に失敗しました",
    credentialRotated: "アプリ資格情報をローテーションしました",
    credentialRotateFailed: "アプリ資格情報のローテーションに失敗しました",
  },
  forms: {
    applicationGrantCreate: "利用ルールを新規作成",
    applicationGrantCreateNamed: "利用ルールを新規作成 · {name}",
    roleMappingCreate: "ロールマッピングを新規作成",
    roleMappingEdit: "ロールマッピングを編集 · {name}",
    roleMappingShort: "ロールマッピング",
    applicationOwner: "所属アプリ",
    applicationDisplayName: "表示名",
    portalDescription: "ポータル説明",
    portalGroup: "ポータル分類",
    applicationName: "内部名",
    appKey: "関連サービスコード",
    baseUrl: "レジストリ由来の入口 URL",
    redirectUris: "OIDC リダイレクト URI",
    claimScopes: "OIDC Scope",
    tokenEndpointAuthMethod: "OIDC クライアント認証方式",
    sortOrder: "並び順",
    applicationDisplayNameHelp: "主に画面表示や選択肢に使うため、比較的安全な文言フィールドです。",
    portalDescriptionHelp:
      "ポータル導線カードの説明文として使います。空の場合は既定の文言を使います。",
    portalGroupHelp:
      "ポータル導線を「よく使う入口」または「その他のツール」のどちらに表示するかを決めます。",
    applicationNameHelp:
      "内部識別用の名称です。現在のアプリ意味と揃え、無関係な値への変更は避けてください。",
    applicationNameLockedHelp:
      "内部名は主にシステム内部と互換用途のために保持しています。稼働中アプリの編集では読み取り専用を推奨します。",
    appKeyHelp:
      "サービス入口レジストリの service_code を入力し、認証設定を唯一のサービス識別子へ関連付けます。新しい入口事実源として扱わないでください。",
    appKeyLockedHelp:
      "関連サービスコードは、この接入アプリをサービスレジストリへ関連付ける安定識別子です。稼働中アプリで変更すると、ログイン連携、ロールマッピング、権限参照に影響する可能性があります。",
    baseUrlHelp:
      "レジストリ由来のアプリ入口 URL を表示するだけです。標準ドメイン、ポート、パスは Identity ではなくサービス入口レジストリで管理します。",
    redirectUrisHelp:
      "1 行に 1 件の完全なコールバック URI を入力します。空の場合は「レジストリ由来の入口 URL + /c/oidc/callback」を既定値として使います。",
    claimScopesHelp:
      "1 行に 1 件の scope を入力します。空の場合は openid のみを既定値として使います。",
    tokenEndpointAuthMethodHelp:
      "public client は none、confidential client は client_secret_post または client_secret_basic を選択します。",
    sortOrderHelp: "ポータル入口の表示順を制御します。数値が小さいほど前に表示されます。",
    applicationStatusHelp:
      "無効化するとアプリ接入ガバナンスと可用状態判定に影響します。通常の文言項目として扱わないでください。",
    tokenEndpointAuthMethodNone: "none（public client）",
    tokenEndpointAuthMethodClientSecretPost: "client_secret_post",
    tokenEndpointAuthMethodClientSecretBasic: "client_secret_basic",
    grantSubject: "利用主体",
    grantObjectValue: "主体値",
    accessLevel: "権限レベル",
    subjectType: "主体種別",
    subjectValue: "主体値",
    targetBusinessRole: "対象業務ロール",
    businessRoleAppOption: "アプリ業務ロール",
    accessOption: "利用可",
    manageOption: "管理可",
    requiredApplicationDisplayName: "表示名を入力してください",
    requiredApplicationName: "内部名を入力してください",
    requiredAppKey: "関連サービスコードを入力してください",
    requiredGrantSubject: "付与対象を選択してください",
    requiredObjectValue: "対象値を選択してください",
    requiredAccessLevel: "権限レベルを選択してください",
    requiredSubjectType: "主体種別を選択してください",
    selectApplicationOwner: "所属アプリを選択",
    applicationOwnerEmpty: "所属アプリ未選択",
    applicationOwnerPickerTitle: "権限バインドの所属アプリを選択",
    applicationOwnerPickerEmpty: "選択可能な ID アプリがありません",
    applicationPickerTitle: "ID アプリを選択",
    permissionApplicationSnapshotMissing:
      "IdentityPermissionDefinitionRead に application_name/application_display_name スナップショットがありません",
    requiredTargetBusinessRole: "対象業務ロールを入力してください",
    requiredApplicationOwner: "所属アプリを選択してください",
  },
} as const;

export const platformAdminIdentityWorkflows = {
  actions: {
    refresh: "更新",
    edit: "編集",
    remove: "削除",
    archive: "アーカイブ",
    customFields: "カスタム項目",
    permissionBindings: "権限バインド",
    createTenant: "テナントを作成",
    createOrganization: "組織を作成",
    createRole: "プラットフォームロールを作成",
    createPermission: "権限点を作成",
    createBinding: "権限バインドを作成",
    viewRawJson: "Raw JSON",
    viewAuditDetail: "監査詳細",
    ...platformAdminIdentityApplicationWorkflows.actions,
  },
  drawers: {
    permissionBinding: "権限バインド · {name}",
    permissionBindingShort: "権限バインド",
    eventRaw: "イベント #{id}",
    eventRawShort: "生イベント",
    eventAudit: "監査イベント #{id}",
    eventAuditShort: "監査イベント",
    ...platformAdminIdentityApplicationWorkflows.drawers,
  },
  confirms: {
    removePermissionBindingTitle: "権限バインドを削除",
    removePermissionBindingDescription: "{type}:{value} を削除しますか？",
    ...platformAdminIdentityApplicationWorkflows.confirms,
  },
  messages: {
    permissionBindingRemoved: "権限バインドを削除しました",
    permissionBindingRemoveFailed: "権限バインドの削除に失敗しました",
    tenantUpdated: "テナントを更新しました",
    tenantCreated: "テナントを作成しました",
    tenantUpdateFailed: "テナントの更新に失敗しました",
    tenantCreateFailed: "テナントの作成に失敗しました",
    organizationUpdated: "組織を更新しました",
    organizationCreated: "組織を作成しました",
    organizationUpdateFailed: "組織の更新に失敗しました",
    organizationCreateFailed: "組織の作成に失敗しました",
    roleUpdated: "プラットフォームロールを更新しました",
    roleCreated: "プラットフォームロールを作成しました",
    roleUpdateFailed: "プラットフォームロールの更新に失敗しました",
    roleCreateFailed: "プラットフォームロールの作成に失敗しました",
    permissionUpdated: "権限点を更新しました",
    permissionCreated: "権限点を作成しました",
    permissionUpdateFailed: "権限点の更新に失敗しました",
    permissionCreateFailed: "権限点の作成に失敗しました",
    noTargetPermission: "対象権限点が選択されていません",
    permissionBindingCreated: "権限バインドを作成しました",
    permissionBindingCreateFailed: "権限バインドの作成に失敗しました",
    ...platformAdminIdentityApplicationWorkflows.messages,
  },
  forms: {
    permissionCreate: "権限点を新規作成",
    permissionEdit: "権限点を編集 · {name}",
    roleCreate: "プラットフォームロールを新規作成",
    roleEdit: "プラットフォームロールを編集 · {name}",
    tenantCreate: "テナントを新規作成",
    tenantEdit: "テナントを編集 · {name}",
    organizationCreate: "組織を新規作成",
    organizationEdit: "組織を編集 · {name}",
    permissionBindingCreate: "権限バインドを新規作成",
    permissionBindingCreateNamed: "権限バインドを新規作成 · {name}",
    tenantScope: "テナント範囲",
    organizationScope: "組織範囲",
    permissionKey: "権限キー",
    resourceKey: "リソースキー",
    actionKey: "操作キー",
    roleKey: "ロールキー",
    tenantName: "テナント名",
    organizationName: "組織名",
    bindingSubject: "バインド対象",
    platformRoleOption: "プラットフォームロール",
    userOption: "特定ユーザー",
    businessRoleOption: "基本身分種別",
    tenantOption: "テナント",
    organizationOption: "組織",
    optionalUnboundTenant: "任意。テナントに紐付けない場合は空欄",
    optional: "任意",
    requiredPermissionKey: "権限キーを入力してください",
    requiredDisplayName: "表示名を入力してください",
    requiredStatus: "状態を選択してください",
    requiredRoleKey: "ロールキーを入力してください",
    requiredTenantName: "テナント名を入力してください",
    requiredTenantKey: "テナントキーを入力してください",
    requiredOrganizationName: "組織名を入力してください",
    requiredOrganizationKey: "組織キーを入力してください",
    requiredPlatformRole: "プラットフォームロールを選択してください",
    requiredBusinessRoleValue: "基本身分種別値を入力してください",
    requiredPriority: "優先度を入力してください",
    requiredBindingSubject: "バインド対象を選択してください",
    requiredBusinessRole: "業務ロールを入力してください",
    ...platformAdminIdentityApplicationWorkflows.forms,
  },
  alerts: {
    ...platformAdminIdentityApplicationWorkflows.alerts,
  },
} as const;
